// extracted by mini-css-extract-plugin
export var quantityInput = "_pa-0";